// extracted by mini-css-extract-plugin
module.exports = {"relogioNumero":"Relogio_relogioNumero__3TTKi","relogioDivisao":"Relogio_relogioDivisao__2mQS1"};